import {
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_HASHTAGS,
    REPORTS_COMPETITORS
} from '@/lib/routes/privateRoutes';

import { aclFeatures } from '@/lib/acl/aclFeatures';

export const REPORT_TYPE_ACCOUNT = 'account';
export const REPORT_TYPE_DASHBOARDS = 'dashboard';
export const REPORT_TYPE_HASHTAGS = 'hashtag';
export const REPORT_TYPE_COMPETITORS = 'competitor';

export const YES = 'yes';
export const NO = 'no';

export const EVERY_MONTH = 'every_month';
export const EVERY_DAY = 'every_day';
export const EVERY_WEEK = 'every_week';
export const EVERY_QUARTER = 'every_quarter';
export const EVERY_YEAR = 'every_year';

export const reportSections = (translate, context = 'create') => [
    {
        label: translate('reports:general.social_profile'),
        icon: 'single-profile',
        url: '/accounts',
        type: REPORT_TYPE_ACCOUNT,
        value: REPORTS_ACCOUNTS,
        href: REPORTS_ACCOUNTS,
        disabled: context === 'edit'
    },
    {
        label: translate('reports:general.dashboard'),
        icon: 'dashboard',
        url: '/dashboards',
        type: REPORT_TYPE_DASHBOARDS,
        value: REPORTS_DASHBOARDS,
        href: REPORTS_DASHBOARDS,
        disabled: context === 'edit'
    },
    {
        label: translate('reports:general.hashtag'),
        icon: 'hashtag',
        url: '/hashtags',
        type: REPORT_TYPE_HASHTAGS,
        value: REPORTS_HASHTAGS,
        href: REPORTS_HASHTAGS,
        disabled: context === 'edit'
    },
    {
        label: translate('reports:general.competitor'),
        icon: 'competitors',
        url: '/competitors',
        type: REPORT_TYPE_COMPETITORS,
        value: REPORTS_COMPETITORS,
        href: REPORTS_COMPETITORS,
        disabled: context === 'edit'
    }
];

export const FormatRadioValues = () => ({
    account: [
        { id: 'report_type_xls', value: `account_xls`, label: 'XLS', name: `report_type` },
        {
            id: 'report_type_pdf',
            value: `account_pdf`,
            label: 'PDF',
            name: `report_type`
        }
    ],
    dashboard: [
        { id: 'report_type_xls', value: `dashboard_xls`, label: 'XLS', name: `report_type` },
        {
            id: 'report_type_pdf',
            value: `dashboard_pdf`,
            label: 'PDF',
            name: `report_type`
        }
    ],
    competitor: [
        { id: 'report_type_xls', value: `competitor_xls`, label: 'XLS', name: `report_type` }
    ],
    hashtag: [{ id: 'report_type_xls', value: `hashtag_xls`, label: 'XLS', name: `report_type` }]
});

export const BrandedRadioValue = (t) => [
    {
        id: 'is_branded_yes',
        value: 'yes',
        label: t('reports:create.value_yes'),
        name: 'brand',
        permissions: aclFeatures.report.white_label.update
    },
    {
        id: 'is_branded_no',
        value: 'no',
        label: t('reports:create.value_no'),
        name: 'brand',
        permissions: aclFeatures.report.white_label.update
    }
];

export const ScheduleRadioValues = (t) => [
    {
        id: 'is_scheduled_yes',
        value: 'yes',
        label: t('reports:create.value_yes'),
        name: 'is_scheduled'
    },
    {
        id: 'is_scheduled_no',
        value: 'no',
        label: t('reports:create.value_no'),
        name: 'is_scheduled'
    }
];

export const SendReportRadioValues = (t) => [
    {
        id: 'send_email_yes',
        value: 'yes',
        label: t('reports:create.value_yes'),
        name: 'send_email'
    },
    { id: 'send_email_no', value: 'no', label: t('reports:create.value_no'), name: 'send_email' }
];

export const FrequencyOptions = (t) => [
    { value: 'every/day', label: t('reports:general.every_day') },
    { value: 'every/week', label: t('reports:general.every_week') },
    { value: 'every/month', label: t('reports:general.every_month') },
    { value: 'every/quarter', label: t('reports:general.every_quarter') },
    { value: 'every/year', label: t('reports:general.every_year') }
];

export const BoxlabelOptions = (t) => ({
    account: {
        title: t('reports:create.placeholder_social'),
        placeholder: t('reports:create.placeholder_social_search'),
        empty: t('reports:create.placeholder_social_empty_list')
    },
    hashtag: {
        title: t('reports:create.placeholder_hashtag'),
        placeholder: t('reports:create.placeholder_hashtag_search'),
        empty: t('reports:create.placeholder_hashtag_empty_list')
    },
    dashboard: {
        title: t('reports:create.placeholder_dashboard'),
        placeholder: t('reports:create.placeholder_dashboard_search'),
        empty: t('reports:create.placeholder_dashboard_empty_list')
    },
    competitor: {
        title: t('reports:create.placeholder_competitor'),
        placeholder: t('reports:create.placeholder_competitor_search'),
        empty: t('reports:create.placeholder_competitor_empty_list')
    }
});

export const Formlabel = (t) => ({
    account: t('reports:create.label_social'),
    hashtag: t('reports:create.label_hashtag'),
    dashboard: t('reports:create.label_dashboard'),
    competitor: t('reports:create.label_competitor')
});

export const FormLabelEdit = (t) => ({
    account: t('reports:create.label_social'),
    hashtag: t('reports:create.label_hashtag'),
    dashboard: t('reports:edit.label_sp_in_dashboard_report'),
    competitor: t('reports:create.label_competitor')
});

export const boxOptionType = (type) => {
    switch (type) {
        case 'hashtag':
            return 'hashtags';
        case 'dashboard':
            return 'dashboards';
        case 'competitor':
            return 'competitors';
        case 'account':
        default:
            return 'social_profiles';
    }
};

export const customDefaultValue = {
    account: {
        report_type: 'account_xls',
        social_profiles: []
    },
    hashtag: {
        report_type: 'hashtag_xls',
        hashtags: []
    },
    dashboard: {
        report_type: 'dashboard_xls',
        dashboards: []
    },
    competitor: {
        report_type: 'competitor_xls',
        competitors: []
    }
};
